export var applyLocationOffset = function (rect, location, isOffsetBody) {
    var top = rect.top, left = rect.left;
    if (isOffsetBody) {
        left = 0;
        top = 0;
    }
    return {
        top: top + location.top,
        left: left + location.left,
        height: rect.height,
        width: rect.width
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/apply-location-offset.js
// module id = 764
// module chunks = 93